import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import services from "../content/services";

const pad = (n) => String(n).padStart(2, "0");

const Caps = ({ limit }) => {
  const list = limit ? services.slice(0, limit) : services;
  return (
    <div className="caps">
      {list.map((s, i) => (
        <Link key={s.slug} to={`/capabilities/${s.slug}`} className="cap">
          <div className="num">{pad(i + 1)} · CAPABILITY</div>
          <h3>{s.title}</h3>
          <p>{s.blurb}</p>
          <span className="more">Read more <FiArrowUpRight /></span>
        </Link>
      ))}
    </div>
  );
};

export default Caps;
